import React from "react";
import { withStyles } from "@material-ui/core/styles";
import GlobalStyles from "../../../assets/js/globalStyles";
import Cookies from "js-cookie";

class UnAuthorized extends React.Component {
  goToLogin = () => {
    Cookies.remove("userName");
    Cookies.remove("email");
    window.location = "/";
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.unAuthorized}>
          <h2 className={classes.textSly}>
            You are not authorized to view or edit this page
          </h2>
          <p style={{ fontSize: "18px" }}>
            Please contact admin for further information
          </p>
          <button className={classes.goBackButton} onClick={this.goToLogin}>
            Go back to login
          </button>
        </div>
      </div>
    );
  }
}

export default withStyles(GlobalStyles)(UnAuthorized);
